var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cabinet-payment-success-view"},[_c('h1',{staticClass:"app-h1"},[_vm._v(" Заказ успешно оплачен ")]),_c('cabinet-payment-info',{attrs:{"payment-id":_vm.paymentId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }